import { StatementPayload, createLangString } from '@/app/tracking/xapi/tincan/client';

export interface QuestionAnsweredStatementParams {
  id: string;
  title: string;
  type: string;
  description?: string;
}

export function createQuestionAnsweredStatement(params: QuestionAnsweredStatementParams) {

  const statement: StatementPayload = {
    verb: {
      id: 'http://adlnet.gov/expapi/verbs/answered',
      display: {
        'en-US': 'answered'
      }
    },
    object: {
      objectType: 'Activity',
      id: params.id,
      definition: {
        type: 'http://adlnet.gov/expapi/activities/question',
        name: createLangString(params.title),
        description: params.description ? createLangString(params.description) : undefined
      }
    }
  };

  return statement;
}
